import CacheCrawler from './CacheCrawler';

export default CacheCrawler;


// WEBPACK FOOTER //
// ./src/components/Query/CacheCrawler/index.ts